import {
  SHOW_ERROR_POPUP,
  HIDE_ERROR_POPUP,
  RETRY_FAILED_ACTION,
} from '../constants/error';

export const showErrorPopupAction = () => ({
  type: SHOW_ERROR_POPUP,
});

export const hideErrorPopupAction = () => ({
  type: HIDE_ERROR_POPUP,
});

export const retryFailedAction = (payload) => ({
  type: RETRY_FAILED_ACTION,
  payload,
});
